import { Component, input } from '@angular/core';
import { ProposalView } from './proposal-view';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';
import { LowerCasePipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'unite-selected-proposal-card',
    templateUrl: './selected-proposal-card.component.html',
    styleUrls: ['./selected-proposal-card.component.scss'],
    imports: [MatCard, MatCardContent, MatIcon, LowerCasePipe, DecimalPipe]
})
export class SelectedProposalCardComponent {
  proposal = input<ProposalView>();

}
